import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, of, shareReplay, tap } from 'rxjs';
import { Country } from '../domain/registrator';
import { MessageService } from './message.service';

const CACHE_SIZE = 1;

export interface Link {
  href: string;
}

export interface HalLinks {
  self: Link;
  [key: string]: Link;
}

export interface HalResource<T> {
  _links: HalLinks;
  _embedded?: {
    [key: string]: T[];
  };
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  endpoint: string = environment.api_url;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  private cache$!: Observable<Array<Country>>;
  private cacheDirty: boolean = true;

  constructor(private http: HttpClient, private messageService: MessageService) { }

  private requestCountries() {
    console.debug('requestCountries');
    return this.http.get<Country[]>(`${this.endpoint}/countries`, {})
      .pipe(
        map((response: Country[]) => response),
        tap((response) => {this.cacheDirty = false; } ),
        catchError(this.handleError<Country[]>('requestCountries', [])),
      )
  }
  public refreshCache() {
    if (this.cache$ || this.cacheDirty) {
      this.cache$ = this.requestCountries().pipe(
        shareReplay(CACHE_SIZE),
      );
    }
  }

  public deleteCache() {
    this.cacheDirty = true;
  }

  get countries() {
    if (!this.cache$ || this.cacheDirty) {
      this.cache$ = this.requestCountries().pipe(
        shareReplay(CACHE_SIZE),
      );
    }
    return this.cache$;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      this.messageService.showMessage('Can\'t load the list of countries', true);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
